export function storeInLocalStorage(key, value) {
  const parseValue = JSON.stringify(value);
  localStorage.setItem(key, parseValue);
}

export function retrieveFromLocalStorage(key) {
  const result = JSON.parse(localStorage.getItem(key));
  return result;
}

export function removeFromLocalStorage(key) {
  localStorage.removeItem(key);
}
